import { css } from 'styled-components';

type FlexType = (positionX: string, positionY: string) => any;

export const flex: FlexType = (positionX: string, positionY) => {
  return css`
    display: flex;
    justify-content: ${positionX || 'center'};
    align-content: ${positionY || 'center'};
    align-items: ${positionY || 'center'};
  `;
};

export const flexColumn: FlexType = (positionX, positionY) => {
  return css`
    display: flex;
    flex-direction: column;
    justify-content: ${positionY || 'center'};
    align-content: ${positionX || 'center'};
    align-items: ${positionX || 'center'};
  `;
};

export const grid = (template: string) => {
  return css`
    display: grid;
    grid-template: ${template};
  `;
};
